import { render, staticRenderFns } from "./TransferArea.vue?vue&type=template&id=2c2231ad&scoped=true&"
import script from "./TransferArea.vue?vue&type=script&lang=js&"
export * from "./TransferArea.vue?vue&type=script&lang=js&"
import style0 from "./TransferArea.vue?vue&type=style&index=0&id=2c2231ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2231ad",
  null
  
)

export default component.exports